// Real Estate / Houses Project action types.
// Namespaced with RE_ so they never collide with other module slices
// (redux action types are a single global namespace).

export const RE_LIST = 'RE_LIST';
export const RE_STORE_ALL = 'RE_STORE_ALL';

export const RE_STORE_HOUSE = 'RE_STORE_HOUSE';
export const RE_REMOVE_HOUSE = 'RE_REMOVE_HOUSE';
export const RE_STORE_PARTNER = 'RE_STORE_PARTNER';
export const RE_REMOVE_PARTNER = 'RE_REMOVE_PARTNER';

export const RE_SAVE_HOUSE = 'RE_SAVE_HOUSE';
export const RE_DELETE_HOUSE = 'RE_DELETE_HOUSE';
export const RE_SAVE_PARTNER = 'RE_SAVE_PARTNER';
export const RE_ADD_PARTNER = 'RE_ADD_PARTNER';
export const RE_DELETE_PARTNER = 'RE_DELETE_PARTNER';
export const RE_SAVE_EXPENSE = 'RE_SAVE_EXPENSE';
export const RE_DELETE_EXPENSE = 'RE_DELETE_EXPENSE';
